
class SearchdiseHook
{
    constructor()
    {
        this.id = "snize-filter-bar";
        this.selector = `#${this.id}`;
    }

    update(facets)
    {
        this.facets = facets;

        this.hookInputClicks();
        this.hookWindowResize();
        this.hookScrollEvent();
        this.createPanel();
        this.refresh();
    }

    hookScrollEvent()
    {
        $(window).scroll(function(e)
        {
        });
    }

    hookInputClicks()
    {
        let selector = `input.snize-product-filters-checkbox`;

        $(selector).bind('click', { self:this }, this.onInputClicked);
    }

    hookWindowResize()
    {
        let self = this;

        /*
        if (window.innerWidth <= 800)
        {
            this.reorganizeFilterForMobile();
        }
        */

        $(window).resize(function()
        {
            self.reorderSortDropdown();
            self.addLabelToSortDropdown();
        });
    }

    onInputClicked(e)
    {
        let self = e.data.self;

        self.refresh();

        /*
        setTimeout(function()
        {
            $([document.documentElement, document.body]).animate({
                scrollTop: $("#snize_results").offset().top - 50
            }, 200);

        }, 0);
        */
    }

    createPanel()
    {
        //let panel = $(".snize-main-panel")[0];
        let panel = $('#snize-search-results-grid-mode');
        let element = $(this.selector);

        if (element.length == 0)
        {
            this.createFilterBarAfterElement(panel)
        }
    }

    createFilterBarAfterElement(panel)
    {
        var content = $(`<ul></ul>`)
            .attr({ id : this.id});

        content.prependTo(panel);
    }

    refresh()
    {
        this.clearFilterBar();
        let data = this.getCheckedElements();
        this.createFilterBarElementsFromData(data);

        this.reorderSortDropdown();
        this.addLabelToSortDropdown();
    }

    clearFilterBar()
    {
        var content = $(this.selector);
        content.empty();
    }

    getCheckedElements()
    {
        let selector = `.snize-filters-sidebar input.snize-product-filters-checkbox[checked='true']`;
        let elements = $(selector);
        let result = [];
        let self = this;

        elements.each(function()
        {
            let facetValue = $(this).attr("name");
            let bucketValue = $(this).attr("value");
            let facetTitle = self.lookupFacetTitle(facetValue);

            result.push({ facetTitle: facetTitle, facetValue: facetValue, bucketValue: bucketValue });
        });

        return result;
    }

    lookupFacetTitle(name)
    {
        let result = this.facets.filter(facet => facet.attribute == name)[0].title;

        return result;
    }

    createFilterBarElementsFromData(data)
    {
        let self = this;

        data.forEach(function(d)
        {
            self.createFilterBarElementFromText(d.facetTitle, d.facetValue, d.bucketValue);
        });

        for (let n = 0; n < this.facets.length; n++)
        {
            if (this.facets[n].attribute == "price" && this.facets[n].buckets[0].selected == "true")
            {
                let from = parseFloat(this.facets[n].buckets[0].left).toFixed(0);
                let to = parseFloat(this.facets[n].buckets[0].right).toFixed(0);

                self.createFilterBarElementFromText("Price", "price", `$${from} - $${to}`);
            }
        }
    }

    createFilterBarElementFromText(facetName, facetValue, bucketName)
    {
        //let title = `${facetName} - ${bucketName}`;
        let title = bucketName;
        let itemClass = 'snize-filter-bar-item';

        let element = $(`<li></li>`)
            .attr({
                class: itemClass, name: facetValue, value: bucketName
            });

        element.bind('click', { self:this }, this.onFilterBarElementClick);

        element.append(`<span class="snize-filter-bar-item-title">${title}</span>`);
        element.append('<i class="snize-product-filters-reset"></i>');

        $(this.selector).append(element);
    }

    onFilterBarElementClick(e)
    {
        let self = e.data.self;

        let facet = $(this).attr("name");
        let bucket = $(this).attr("value");

        if (facet == "price")
        {
            let selector = '.snize-product-filters-reset[data-se-facet-attribute="price"]';

            $(selector).trigger('click');
        }
        else
        {
            let selector = "";

            if ($(window).width() > 450)
            {
                selector = `input.snize-product-filters-checkbox[name=${facet}][value="${bucket}"]`;
            }
            else
            {
                selector = `.snize-filters-sidebar-clone input.snize-product-filters-checkbox[name=${facet}][value="${bucket}"]`;
            }


            $(selector).trigger('click');
        }

        self.refresh();
    }

    reorderSortDropdown()
    {
        let items = $('ul.snize-main-panel-dropdown-content li');
        let order =
        [
            'snize-main-panel-dropdown-price-asc',
            'snize-main-panel-dropdown-price-desc',
            'snize-main-panel-dropdown-sales_amount-desc',
            'snize-main-panel-dropdown-created-desc',
            'snize-main-panel-dropdown-created-asc',
            'snize-main-panel-dropdown-reviews_average_score-desc',
            'snize-main-panel-dropdown-reviews_average_score-asc'
        ];

        items.sort(function(a, b)
        {
            let classesA = $(a).children(0).attr("class").split(' ');
            let classesB = $(b).children(0).attr("class").split(' ');

            let resultA = classesA.filter(function(x)
            {
                return order.indexOf(x) != -1;
            });

            let resultB = classesB.filter(function(x)
            {
                return order.indexOf(x) != -1;
            });

            if (resultA.length == 1 && resultB.length == 1)
            {
                let orderA = order.indexOf(resultA[0]);
                let orderB = order.indexOf(resultB[0]);
                let result = orderA - orderB;

                return result;
            }

            if (resultA.length == 1 || resultB.length == 1)
            {
                return -1;
            }

            return 0;
        });

        $('ul.snize-main-panel-dropdown-content').empty();
        items.appendTo('ul.snize-main-panel-dropdown-content');
    }

    addLabelToSortDropdown()
    {
        let exists = $('.sort-by-label').length == 1;

        if (exists == false)
        {
            $('.snize-main-panel-dropdown')
                .after('<span class="sort-by-label desktop-only">Sort By: </span>');
        }
    }

    createMobileFilterElements()
    {

    }


}

class MobileFilterHook
{
    constructor()
    {
        this.containerClass = 'snize-mobile-container';
        this.filterHeader = null;
        this.sortHeader = null;
        this.sortPanelClone = null;
        this.filterPanelClone = null;
    }

    update()
    {
        if ($(window).width() > 450)
        {
            return;
        }

        this.createElements();
    }

    createElements()
    {
        let self = this;
        let containerElement = this.createContainerElement();
        let headerElement = this.createHeaderElement(containerElement);
        let contentElement = this.createContentElement(containerElement);
        this.filterHeader = this.createFilterHeaderElement(headerElement);
        this.sortHeader = this.createSortHeaderElement(headerElement);
        this.sortPanelClone = this.cloneSortPanel(contentElement);
        this.filterPanelClone = this.cloneFilterPanel(contentElement);


        this.makeSticky(containerElement);
        this.makeSticky($('#snize-filter-bar'));

        this.hookPriceFilterChange(this.filterPanelClone);

        this.filterHeader.off();
        this.filterHeader.bind('click', { self: this }, function()
        {
            self.hidePanel(self.sortPanelClone);
            self.togglePanel(self.filterPanelClone);

        });

//         $('.snize-mobile-filter-header').on('click', function() {
//             $('.snize-main-panel-mobile-filters').trigger('click');
//         })

        $( ".snize-mobile-container .snize-selected-filters-container" ).first().remove();
        $( ".snize-mobile-container-header" ).after( $('.snize-main-panel .snize-selected-filters-container') );
      
      	$('.snize-mobile-filter-header-filter').on('click', function() {

            $(this).toggleClass('selected')
            // $('.snize-mobile-container-content').addClass('active')

            if ($('.snize-mobile-filter-header-filter').hasClass('filter-close')) {
                $('.snize-mobile-container-content').removeClass('active')
                $(this).removeClass('filter-close')
                $('.snize-modal .snize-close-button').trigger('click');
            } else {
                $('.snize-mobile-container-content').addClass('active')
                $(this).addClass('filter-close')
                $( ".snize-mobile-container-content" ).append( $('#snize-modal-mobile-filters-dialog') );
                $('.snize-main-panel-mobile-filters').trigger('click');
            }
        })
        
        $('.snize-close-button').on('click', function() {
            $('.snize-mobile-filter-header').removeClass('selected');
        })

        this.sortHeader.off();
        this.sortHeader.bind('click', { self: this }, function()
        {
            self.hidePanel(self.filterPanelClone);
            self.togglePanel(self.sortPanelClone);
        });

        $('body').scroll(function()
        {
            let sortPanel = $('.snize-main-panel-dropdown');

            sortPanel.hide();
            sortPanel.find(a).hide();
        });

        $('.snize-product-filters-block').show();

        $('.snize-product-filters-title').bind('click', { self: this}, function(e)
        {
            $(this).toggleClass("open");
            $(this).siblings("ul").toggle();
        });

        this.filterPanelClone.find('.snize-product-filters-title:first').hide();

        window.setTimeout(function()
        {
            $('.snize-main-panel-dropdown').hide();
        }, 0);


        this.updatePanelIndicators();

//         $(".snize-product-filters-block").each(function (i, e) {
//                   title = $(this).find(".snize-product-filters-title span");
//                   if (title.html() === 'Stone Cut') {
//                     $(this).find('.snize-product-filters-title').append("<span class='stonecut_filter'>i</span>");
//                     $(".stonecut_filter").on('click', function (e) {
//                       e.preventDefault();

//                       $(".stones-popup").show();
//                       return false;
//                     });
//                   }
//                 });

    }

    hidePanel(panel)
    {
        panel.hide();

        this.updatePanelIndicators();
    }

    togglePanel(panel)
    {
        panel.toggle();

        this.updatePanelIndicators();
    }

    updatePanelIndicators()
    {
        this.updatePanelDirectionIndicator(this.sortPanelClone, this.sortHeader);
        this.updatePanelDirectionIndicator(this.filterPanelClone, this.filterHeader);
    }

    updatePanelDirectionIndicator(panel, header)
    {
        if (panel.is(":visible"))
        {
            header.addClass('selected');
        }
        else
        {
            header.removeClass('selected');
        }
    }

    createContainerElement()
    {
        let className = `.${this.containerClass}`;
        let existing = $(className);

        if (existing.length > 0)
        {
            return existing;
        }

        let container = `<div class="${this.containerClass}"></div>`;
        let containerElement = $(container);

        containerElement.insertAfter($('.snize-product-filters'));

        return containerElement;
    }

    createHeaderElement(parentElement)
    {
        let className = `.${this.containerClass}-header`;
        let existing = $(className);

        if (existing.length > 0)
        {
            return existing;
        }

        let headerElement = $(`<div class="${this.containerClass}-header"></div>`)

        parentElement.append(headerElement);

        return headerElement;
    }

    createContentElement(parentElement)
    {
        let className = `${this.containerClass}-content`;
        let existing = $("." + className);

        if (existing.length > 0)
        {
            return existing;
        }

        let contentElement = $(`<div class="${className}"></div>`)

        parentElement.append(contentElement);

        return contentElement;
    }

    createFilterHeaderElement(parentElement)
    {
        let className = 'snize-mobile-filter-header-filter';
        let existing = $(`.${className}`);

        if (existing.length > 0)
        {
            return existing;
        }

        let filterHeader = $(`<span class="snize-mobile-filter-header d ${className}">Filter By <span class="arrow">&#9660;</span></span>`); // TODO button

        parentElement.append(filterHeader);

        return filterHeader;
    }

    createSortHeaderElement(parentElement)
    {
        let className = 'snize-mobile-filter-header-sort';
        let existing = $(`.${className}`);

        if (existing.length > 0)
        {
            return existing;
        }

        let sortHeader = $(`<span class="snize-mobile-filter-header ${className}">Sort By <span class="arrow">&#9660;</span></span>`);

        parentElement.append(sortHeader);

        return sortHeader;
    }

    cloneSortPanel(targetElement)
    {
        let self = this;

        let existing = $('.snize-main-panel-dropdown-clone');
        let sortPanel = $('.snize-main-panel-dropdown');

        setTimeout(function()
        {
            sortPanel.hide();
        }, 0);

        $(window).resize(function()
        {
            setTimeout(function()
            {
                sortPanel.hide();
            }, 0);
        });

        if (existing.length > 0)
        {
            return existing;
        }

        let sortPanelClone = sortPanel.clone(true);

        sortPanelClone.appendTo(targetElement);

        this.cleanSortPanelClone(sortPanelClone);

        sortPanelClone.addClass('snize-main-panel-dropdown-clone');

        sortPanelClone.find('a').bind('click', { self: this }, function(e)
        {
            sortPanel = $('.snize-main-panel-dropdown');

            let index = sortPanelClone.find('ul a').index(e.target);
            let sortPanelUl = sortPanel.find('.snize-main-panel-dropdown-content');
            let a = $(sortPanelUl.find('a')[index])[0];

            a.click();

            sortPanelClone.find('ul a').removeClass('checked');
            $(e.target).addClass('checked');

            setTimeout(function()
            {
                self.togglePanel(sortPanelClone);
            }, 500);
        });

        return sortPanelClone;
    }

    cleanSortPanelClone(panel)
    {
        panel.removeClass();
        panel.find('ul').removeClass().show();
        panel.find('a:first').remove();
        panel.find('a').removeAttr('href').removeClass();
        panel.find('li').removeClass();

        let elements = panel.find('a');

        for (let n = 0; n < elements.length; n++)
        {
            if ($(elements[n]).text().length == 0)
            {
                $(elements[n]).hide();
            }
        }

        panel.hide();
    }

    cloneFilterPanel(targetElement)
    {
        let self = this;

        if ($('.snize-filters-sidebar-clone').length > 0)
        {
            $('.snize-filters-sidebar-clone').remove();
        }

        let filterPanel = $('.snize-filters-sidebar');
        let filterPanelClone = filterPanel.clone(true);
        filterPanelClone.removeClass();
        filterPanelClone.appendTo(targetElement);

        filterPanelClone.addClass('snize-filters-sidebar-clone');

        filterPanel.hide();
        filterPanelClone.hide();
        filterPanelClone.find('input').off();

        filterPanelClone.find('input').bind('click', { self: this }, function(e)
        {
            if (!e.target.attributes['name'])
            {
                return;
            }

            let name = e.target.attributes['name'].value;
            let value = e.target.attributes['value'].value;
            let selector = `input[name="${name}"][value="${value}"]`;
            let element = filterPanel.find(selector);

            self.hidePanel(filterPanelClone);

            $(element).trigger('click');

            window.setTimeout(function()
            {
                $('.snize-main-panel-dropdown').hide();
            }, 0);
        });

        return filterPanelClone;
    }

    makeSticky(element)
    {
        let viewportOffset = element[0].getBoundingClientRect();
        let sticky = viewportOffset.top - 30;

        $(window).scroll(function ()
        {
            if (window.pageYOffset > sticky)
            {
                element.addClass("sticky");
            }
            else
            {
                element.removeClass("sticky");
            }

            $('.snize-main-panel-dropdown').hide();
        });
    }

    hookPriceFilterChange(clonedElement)
    {
        let cloned = clonedElement.find('.snize-price-range-input');
        let original = $('.snize-filters-sidebar .snize-price-range-input');

        cloned.change(function (e)
        {
            let index = cloned.index(e.target);

            original[index].value = e.target.value;
            $(original[index]).trigger('change');

            clonedElement.toggle();
        });
    }
}

var searchdiseHook = new SearchdiseHook();
var mobileFilterHook = new MobileFilterHook();

$(document).ready(function()

{
    function waitForGlobal(key, subkey, callback)
    {
        if (window[key][subkey])
        {
            callback();
        }
        else
        {
            setTimeout(function()
            {
                waitForGlobal(key, subkey, callback);
            }, 100);
        }
    };

    waitForGlobal("Searchanise", "$", function()
    {
        Searchanise.$.ajaxSetup(
        {
            complete: function(xhr)
            {
                if (this.url.indexOf("https://www.searchanise.com/getresults") == 0 || this.url.indexOf("https://www.searchanise.com/getresults") == 0)
                {
                    searchdiseHook.update(xhr.responseJSON.facets);
                    mobileFilterHook.update();
                }
            }
        });
    });

  function setStoneIcon() {
  }


  setInterval(function () {
    if ($(".stonecut_filter").size() === 0) {
      $(".snize-product-filters-block").each(function (i, e) {
        title = $(this).find(".snize-product-filters-title span");
        if (title.html().indexOf('Stone Cut') === 0) {
          $(this).find('.snize-product-filters-title').append("<span class='stonecut_filter'>ⓘ</span>");
          $(".stones-popup,.header__main").on('click', function () {
          	$('.stones-popup').hide();
          });

          $(".stones-popup__inner").on('click', function (e) {
          	e.preventDefault();
            e.stopImmediatePropagation();
          });


          $(".stones-popup .close").on('click', function () {
            $(".stones-popup").hide();
          });



          $(".stonecut_filter").on('click', function (e) {
            e.preventDefault();

            $(".stones-popup").show();
            return false;
          });
        }
      });
    }
  });

});
